var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPython(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9193 5.5045C12.9193 5.5045 12.1267 9.05624e-07 24.8198 0C38.0846 0 37.0598 6.63653 37.0598 6.63653V17.6031C37.0598 24.2355 30.3101 24.1264 30.3101 24.1264H18.2964C11.0922 24.1264 11.3203 31.2157 11.3203 31.2157V37.1589H7.08934C7.08934 37.1589 -9.05624e-07 37.6131 0 24.8056C0 11.9981 8.12232 12.9193 8.12232 12.9193H25.0462V11.2071H12.9334L12.9193 5.5045ZM20.3199 6.01391C20.3199 4.80878 19.3459 3.83475 18.1408 3.83475C16.9357 3.83475 15.9616 4.80878 15.9616 6.01391C15.9616 7.21904 16.9357 8.19307 18.1408 8.19307C19.3459 8.19307 20.3199 7.21904 20.3199 6.01391Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0807 44.2351C37.0807 44.2351 37.8734 49.7396 25.1802 49.7396C11.9154 49.7396 12.9402 43.1031 12.9402 43.1031V32.1366C12.9402 25.5041 19.6899 25.6132 19.6899 25.6132H31.7036C38.9078 25.6132 38.6797 18.5239 38.6797 18.5239V12.5807H42.9107C42.9107 12.5807 50 12.1266 50 24.934C50 37.7415 41.8777 36.8203 41.8777 36.8203H24.9538V38.5325H37.0666L37.0807 44.2351ZM29.6801 43.7257C29.6801 44.9308 30.6541 45.9049 31.8592 45.9049C33.0643 45.9049 34.0384 44.9308 34.0384 43.7257C34.0384 42.5206 33.0643 41.5466 31.8592 41.5466C30.6541 41.5466 29.6801 42.5206 29.6801 43.7257Z",
    fill: "#FEFEFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.56fe97b79d654194ab3fe04903dbe20e.svg";
export { ForwardRef as ReactComponent };